enum LicenceState {
    ACTIVE = 'active',
    SUSPENDED = 'suspended',
    SHUTDOWN = 'shutdown',
}

export default LicenceState;
